import OpenAPIRegistration from './OpenAPIRegistration';

export default OpenAPIRegistration;